export const uuidToNumber = (uuid)=>{
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(uuid)) {
        throw new Error('Invalid UUID format');
    }
    const hexString = uuid.replace(/-/g, '');
    return parseInt(hexString, 16);
};
export const numberToUUID = (num)=>{
    if (!Number.isInteger(num) || num < 0 || num > 2 ** 128 - 1) {
        throw new Error('Number must be a positive integer less than 2^128');
    }
    const hexString = num.toString(16).padStart(32, '0');
    return [
        hexString.substr(0, 8),
        hexString.substr(8, 4),
        hexString.substr(12, 4),
        hexString.substr(16, 4),
        hexString.substr(20, 12)
    ].join('-');
};
